@if (!(isLoggedIn$ | async) || fullScreenLayout) {
  <div>
    <router-outlet></router-outlet>
  </div>
} @else {
  <div class="d-flex">
    @if (loader$ | async) {
      <div class="page-loader">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }
    <app-sidenav
      (logout)="onLogout()"
      [items]="navItems"
      [user]="user$ | async"
      class="flex-grow-1 sidenav position-sticky h-100"
    >
    </app-sidenav>
    <div class="app-scroll-container">
      @if (studioSiteLoaded$ | async) {
        <div class="app-container">
          <router-outlet
            ngxInactivity
            (ngxInactivityCallback)="oktaSessionService.userIsActive()"
          ></router-outlet>
        </div>
      }
    </div>
  </div>
}
